import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { rpmLogsData } from '../mockData/rpm-logs-data';
import { rpmReadings } from '../mockData/rpm-readings-data';

const RpmLogsApi = [
  rest.get(`${API_ROOT}rpm-logs`, (req, res, ctx) => res(ctx.json(rpmLogsData))),
  rest.get(`${API_ROOT}rpm-logs/5`, (req, res, ctx) => res(ctx.json(rpmReadings))),
  rest.post(`${API_ROOT}rpm-logs`, (req, res, ctx) => res(ctx.json({ success: true }))),
];
export default RpmLogsApi;
